import { MenuItem } from './menu-item.interface'; // adjust path as needed


export const PROFESSIONAL_MENU_ITEMS: MenuItem[] = [
  {
    label: 'News Feeds',
    icon: 'newspaper',
    route: '/profile/my-dashboard',
    requiredPermission: 'news_feed_modules_permission',
  },
  {
    label: 'View Profile',
    icon: 'account_circle',
    route: '/profile/detail',
    exact: true,
  },
  {
    label: 'My Directory',
    icon: 'folder_open',
    route: '/profile/directory',
    exact: true,
    requiredPermission: 'directory_minimal_permission',
  },

  // { label: 'My Favourites', icon: 'favorite', route: '/profile/favourites' },
  // { label: 'Directions', icon: 'pin_drop', route: '/profile/address' },
  {
    label: 'Job Seek',
    icon: 'search',
    action: 'toggleJobcornerMenuProfessional',

    children: [
      { label: 'Job Profile', route: '/profile/directory/add-job-profile/job' },
      { label: 'Applied Jobs', route: '/profile/applied-job-listing' },
      { label: 'Enquiries', route: '/profile/enquiries-job-listing' },
    ],
  },
  {
    label: 'My LearningHub',
    icon: 'grading',
    route: '/profile/registered-course',
    exact: true,
  },
  // { label: 'Banners', route: '/profile/banners/banner-list', class: 'noIconMenu', requiredPermission: 'banner_modules_permission' },

  // { label: 'Pre-Owned Supplies', route: '/profile/pre-owned-supplies', class: 'noIconMenu' },
  // { label: 'My Orders', icon: 'shopping_cart', route: '/profile/my-pre-owned-orders' },
  // { label: 'My Bids', icon: 'gavel', route: '/profile/my-bids' },
  // { label: 'Pre owned order', route: '/profile/pre-owned-orders/list', class: 'noIconMenu' },
  // { label: 'Orders', route: '/profile/orders', class: 'noIconMenu' },
  // { label: 'Account Pay Requests', icon: 'payments', route: '/profile/account-pay-requests' },
  // { label: 'My Enquiries', icon: 'contact_support', route: '/profile/enquiries' },
  { label: 'Subscriptions', route: '/profile/membership', class: 'noIconMenu' },

  {
    label: 'Support Requests',
    icon: 'support_agent',
    route: '/profile/support-management',
  },
];
